@use "../../../../../../../styles/Colors.scss" as Colors;
@use "../../../../../../../styles/Constants.scss" as Constants;


.time {

	&__total-split-time-container {
		display: flex;
		flex-direction: row;
		gap: Constants.$val-spacing-m;
		justify-content: space-between;
	}

	&__total {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: Constants.$val-spacing-s Constants.$val-spacing-m;
		border-top-left-radius: Constants.$val-borderRadius;
		border-top-right-radius: Constants.$val-borderRadius;
	
		&--greyed {
			background-color: Colors.$col-greyBackground;
		}
	
		&--error {
			background-color: Colors.$col-redBackground;
		}
	
		&__tracked-entry {
			color: Colors.$col-blue;
			margin-right: Constants.$val-spacing-m;
			text-align: right;
			font-weight: bold;
		}
	}

}